import React from 'react';

const PainScaleType = ({ question, dispatch }) => {
  return <>
    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((pain, i) => {
      return <div key={i} className="form-check form-check-inline">
        <input
          onClick={(e) => { dispatch(e.target.value) }}
          id={`painscale_${question.linkId}_${i}`}
          name={`painscale_${question.linkId}`}
          className="form-check-input"
          type="radio"
          value={pain}
        />

        <label
          htmlFor={`painscale_${question.linkId}_${i}`}
          className="form-check-label"
        >{pain}</label>
      </div>
    })}
  </>;
}

export default PainScaleType;